export const classes = {
    BOOTSTRAPPED: 'bootstrapped',
};

export const strings = {
    SVG_NS: 'http://www.w3.org/2000/svg',
};
